import quotationActions from '../quotation/actions';
import aiRecorderActions from '../aiRecorder/actions';
import agendaActions from '../agenda/actions';
import recordsActions from '../records/actions';
import memedActions from '../memed/actions';
import examsActions from '../exams/actions';
import aiActions from '../ai/actions';
import inventoryActions from '../inventory/actions';
import patientAlertActions from '../patientAlert/actions';
import tvActions from '../tv/actions';
import financialActions from '../financial/actions';

// Catálogo das funcionalidades rastreadas. Cada entrada:
//  - feature: chave estável usada nos contadores e no dashboard
//  - label: rótulo exibido
//  - level: 'professional' | 'account' (de quem a ação normalmente é; orienta a atribuição)
//  - actionTypes: VALORES reais das constantes (importadas — não strings soltas, pois alguns
//    valores diferem do nome, ex.: ai MARK_PATIENT_AS_ATTENDED_SUCCESS = 'AI_MARK_...')
//  - getProfessionalUid?(action, state): extrator opcional do profissional responsável
export const USAGE_CATALOG = [
  {
    feature: 'ai_recorder',
    label: 'Transcrição IA',
    level: 'professional',
    actionTypes: [aiRecorderActions.AI_RECORDER_PROCESS_AUDIO_SUCCESS],
  },
  {
    feature: 'quotation_created',
    label: 'Orçamento criado',
    level: 'professional',
    // REQUEST (não SUCCESS): é o pedido que carrega o profissional (payload.quotation.professionalId).
    // Contamos o pedido, não a confirmação — atribuição correta vale mais que a rara falha.
    actionTypes: [quotationActions.SAVE_QUOTATION_REQUEST],
  },
  {
    feature: 'quotation_sent',
    label: 'Orçamento enviado',
    level: 'professional',
    actionTypes: [quotationActions.SEND_WHATSAPP_SUCCESS],
  },
  {
    feature: 'appointment_created',
    label: 'Agendamento criado',
    level: 'professional',
    // REQUEST (não SUCCESS): o pedido carrega o profissional (payload.professional no manual;
    // payload.selectedData.professional no lote). O _SUCCESS não carrega o médico.
    actionTypes: [
      agendaActions.MANUALLY_SET_NEW_APPOINTMENT_REQUEST,
      agendaActions.PERSIST_BATCHED_APPOINTMENT_REQUEST,
    ],
  },
  {
    feature: 'appointment_finalized',
    label: 'Atendimento finalizado',
    level: 'professional',
    // SÓ FINALIZE_APPOINTMENT_SUCCESS. Finalizar com pagamento dispara também
    // FINALIZE_APPOINTMENT_WITH_INVOICE_SUCCESS (parte de nota/pagamento) — contar os
    // dois marcava 2× a mesma finalização (successes não têm id p/ dedup).
    actionTypes: [agendaActions.FINALIZE_APPOINTMENT_SUCCESS],
  },
  {
    feature: 'appointment_missed',
    label: 'Consulta faltou',
    level: 'professional',
    // REQUEST (caminho único): payload = selectedData do agendamento, que traz .professional.
    actionTypes: [agendaActions.PATIENT_MISSED_APPOINTMENT_REQUEST],
  },
  {
    feature: 'record_saved',
    label: 'Prontuário preenchido',
    level: 'professional',
    // O prontuário (texto livre) NÃO tem action de sucesso — o save dispara
    // SAVE_RECORD_REQUEST e o "sucesso" vem de um re-fetch (que também roda em
    // visualizações, logo não serve). Usamos o REQUEST como sinal do save.
    // SAVE_PATIENT_RECORD_FORM_SUCCESS cobre o prontuário em formulário estruturado.
    actionTypes: [
      recordsActions.SAVE_RECORD_REQUEST,
      recordsActions.SAVE_PATIENT_RECORD_FORM_SUCCESS,
    ],
  },
  {
    feature: 'prescription',
    label: 'Receita (Memed)',
    level: 'professional',
    // Memed não tem action de sucesso (sucesso = re-fetch); usamos o REQUEST do save.
    actionTypes: [memedActions.SAVE_MEMED_PRESCRIPTION_REQUEST],
  },
  {
    feature: 'exam',
    label: 'Exames',
    level: 'professional',
    // REQUEST_EXAMS (não os _SUCCESS): só o REQUEST carrega payload.professional + requestSecretary;
    // os _SUCCESS são dispatchados sem payload. Um pedido = um dispatch.
    actionTypes: [examsActions.REQUEST_EXAMS],
  },
  {
    feature: 'ai_assistant',
    label: 'IA / WhatsApp',
    level: 'account',
    actionTypes: [aiActions.MARK_PATIENT_AS_ATTENDED_SUCCESS],
  },
  {
    feature: 'ai_appointment',
    label: 'Agendamento por IA',
    level: 'professional',
    actionTypes: [],
  },
  {
    feature: 'ai_message',
    label: 'Mensagens enviadas por IA',
    level: 'professional',
    actionTypes: [],
  },
  {
    feature: 'whatsapp_message',
    label: 'Mensagem WhatsApp enviada',
    level: 'professional',
    actionTypes: [],
  },
  {
    feature: 'inventory_op',
    label: 'Estoque',
    level: 'account',
    actionTypes: [
      inventoryActions.DEPOSIT_INVENTORY_ITEM_SUCCESS,
      inventoryActions.WITHDRAW_INVENTORY_ITEM_SUCCESS,
      inventoryActions.TRANSFER_INVENTORY_SUCCESS,
    ],
  },
  {
    feature: 'patient_alert',
    label: 'Alerta de paciente',
    level: 'professional',
    actionTypes: [patientAlertActions.INSERT_PATIENT_ALERT_SUCCESS],
  },
  {
    feature: 'tv_call',
    label: 'Chamada na TV',
    level: 'account',
    actionTypes: [tvActions.CALL_PATIENT_TV_SUCCESS],
  },
  {
    feature: 'financial_entry',
    label: 'Lançamento financeiro',
    level: 'account',
    actionTypes: [
      financialActions.CREATE_MANUAL_INCOME_SUCCESS,
      financialActions.CREATE_MANUAL_EXPENSE_SUCCESS,
      financialActions.CONFIRM_CASH_PAYMENT_SUCCESS,
    ],
  },
];

// Todos os action types rastreados (achatado), para o takeEvery. Filtra undefined por segurança.
export const TRACKED_ACTION_TYPES = USAGE_CATALOG
  .reduce((acc, entry) => acc.concat(entry.actionTypes), [])
  .filter(Boolean);

// Mapa reverso: action.type -> entrada do catálogo.
export const ACTION_TO_ENTRY = USAGE_CATALOG.reduce((acc, entry) => {
  entry.actionTypes.forEach((type) => {
    if (type) acc[type] = entry;
  });
  return acc;
}, {});

// Ordem e rótulos das funcionalidades para o dashboard.
export const FEATURE_ORDER = USAGE_CATALOG.map((entry) => entry.feature);
export const FEATURE_LABELS = USAGE_CATALOG.reduce((acc, entry) => {
  acc[entry.feature] = entry.label;
  return acc;
}, {});
